import React, { useState, useEffect, useRef } from 'react';
import PortfolioVideo from '../../Resources/Files/Portfolio-Video.mp4'
import {PortfolioData} from '../../Resources/Data/PortfolioData'
import '../../CSS/PortfolioPage.css';

function PortfolioPage({showModal, modalTrigger} : {showModal:boolean, modalTrigger:Function}) {

    const videoRef = useRef<HTMLVideoElement>(null);

    // Optimize video performance by pausing when not in view
    useEffect(() => {
        const video = videoRef.current;
        if (!video) return;

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        video.play();
                    } else {
                        video.pause();
                    }
                });
            },
            { threshold: 0.5 }
        );

        observer.observe(video);

        return () => {
            observer.disconnect();
        };
    }, []);

    const PortfolioCard = ({card, showModal, modalTrigger}:{card:any, showModal:boolean, modalTrigger:Function}) => {

        const [hover, setHover] = useState(false);
        const [imageLoaded, setImageLoaded] = useState(false);

        const handleImageLoad = () => {
            setImageLoaded(true);
        };

        return (
            <div 
                className="Card"
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
                onClick={() => modalTrigger(card.modal, {showModal})}>

                    {hover ? 
                        <div className="Back">
                            <h1>{card.header}</h1>
                            <h2>{card.type}</h2> 
                        </div>
                    :
                        null
                    }

                    <div className="Front">
                        <img 
                            src={card.image} 
                            alt={card.header} 
                            loading="lazy"
                            decoding="async"
                            onLoad={handleImageLoad}
                            data-loaded={imageLoaded}
                            style={{ opacity: imageLoaded ? 1 : 0 }}
                        />
                    </div>

            </div>
        )
    }

    return (
        <div className="Portfolio-frame">

            <div className="Video-frame">
                <p>WILL LIAO 2021 <br></br> TAM'SUI, TAIWAN <br></br> SHOT BY DRONE </p>
                <video ref={videoRef} className="Video" autoPlay loop muted>
                    <source src={PortfolioVideo} type='video/mp4' />
                </video>
            </div>

            <div className="Content">
                <div className="Header">
                    <h1>MY PORTFOLIO</h1>
                </div>

                <div className="Grid">
                    {PortfolioData.filter((item:any) => item.showItem === true).map((item:any) => 
                        <PortfolioCard card={item} key={item.id} showModal={showModal} modalTrigger={modalTrigger} />
                    )}
                </div>
            </div>

        </div>
    );

}

export default PortfolioPage;